import { render, staticRenderFns } from "./RegistrationConfirm.vue?vue&type=template&id=473e1837&"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirm.vue?vue&type=style&index=0&id=473e1837&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports